import * as React from 'react';

const update = (x: number) => x + 1;

function useForceUpdate() {
  return React.useReducer(update, 0);
}

export default useForceUpdate;
